import { useState as m, useRef as r, useEffect as o } from "react";
import { a as d, i as p } from "./isClient-ec947a14.mjs";
const g = (c, a) => {
  const [i, u] = m(!1), e = r(a), h = r(d && p("matchMedia"));
  return o(() => {
    e.current = a;
  }, [a]), o(() => {
    if (!h.current)
      return;
    const t = window.matchMedia(c), s = () => {
      var n;
      (n = e.current) == null || n.call(e, t.matches), u(t.matches);
    };
    return s(), t.addEventListener("change", s), () => t.removeEventListener("change", s);
  }, [c]), i;
};
export {
  g as u
};
